export default "__VITE_PUBLIC_ASSET__006605b6__"